import {createSlice} from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'downloadReportTicketHistory',
    initialState: {
        isRequesting: false,
        error: null,
        isDone: false,
        data: null,
    },
    reducers: {
        download_report_ticket_history: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
    }
});

export const {reducer, actions} = slice;

export default reducer;